import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';

const tracks = [
  {
    icon: 'ri-book-open-line',
    title: 'Formation technique',
    text: "Chaudronnerie, tuyauterie, soudure multi-procédés, montage et échafaudage : théorie, atelier et évaluation pratique.",
  },
  {
    icon: 'ri-user-star-line',
    title: 'Placement de personnel',
    text: "Soudeurs, chaudronniers, tuyauteurs et monteurs sélectionnés pour votre chantier, prêts à intégrer vos équipes.",
  },
];

export default function Training() {
  return (
    <section className="relative overflow-hidden bg-primary-900 py-20 text-background-50 md:py-28">
      <div className="absolute inset-0 hatch-lines-light opacity-20" />
      <div className="container-wide relative z-10">
        <div className="grid items-center gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16">
          <div>
            <Reveal>
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-accent-500" />
                <span className="label-mono text-accent-400">Compétences &amp; transmission</span>
              </div>
              <h2 className="display-title mt-5 text-4xl md:text-5xl lg:text-6xl">
                Nous formons aussi
                <br />
                les mains de demain
              </h2>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-background-200">
                Un atelier ne vaut que par ses compagnons. SGSCTIC transmet les gestes du métier et
                met à disposition des profils techniques déjà évalués, pour que votre chantier
                démarre avec des équipes opérationnelles.
              </p>
            </Reveal>

            <div className="mt-10 grid gap-4 sm:grid-cols-2">
              {tracks.map((track, index) => (
                <Reveal key={track.title} delay={index * 120}>
                  <div className="h-full rounded-lg border border-background-50/15 bg-background-50/5 p-6 transition-colors duration-300 hover:border-accent-400/60 hover:bg-background-50/10">
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                      <i className={`${track.icon} text-xl`} />
                    </span>
                    <h3 className="mt-4 font-heading text-xl font-semibold uppercase tracking-wide">
                      {track.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-background-200">{track.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={300}>
              <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/formation"
                  className="btn-shine flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-foreground-950 transition-colors hover:bg-accent-400"
                >
                  Découvrir la formation
                  <i className="ri-arrow-right-up-line text-base" />
                </Link>
                <Link
                  to="/offres"
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-6 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-background-50 transition-colors hover:bg-background-50 hover:text-primary-900"
                >
                  Voir les offres
                </Link>
              </div>
            </Reveal>
          </div>

          <Reveal variant="clip" delay={140}>
            <div className="relative">
              <div className="aspect-[4/5] w-full overflow-hidden rounded-lg border border-background-50/15">
                <img
                  src="https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-06-at-13.50.19.jpeg"
                  alt="Session de formation en soudure dans l'atelier SGSCTIC"
                  title="Formation soudure et chaudronnerie à Douala"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 -left-4 hidden bg-background-50 px-6 py-5 text-foreground-950 sm:block">
                <p className="font-heading text-4xl font-semibold leading-none text-primary-600">
                  100%
                </p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-foreground-600">
                  Pratique en atelier
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}